import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

/** Components */
import SearchBox from './../../components/SearchBox/SearchBox';
import DataTable from '../../components/Table/DataTable';

/** Services */
import { getRecipientsData, getRecipientsDataBySearch } from '../../services/recipients';

/** Actions */
import { showAlert } from '../../store/ducks/alert';

const Recipients = ({ location, match }) => {
  const dispatch = useDispatch();

  const [recipients, setRecipients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  const headers = ['id', 'paymentOriginId', 'channelId', 'status', 'enabled', 'paymentOriginToken'];

  useEffect(() => {
    getRecipients();
  }, []);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    getRecipients(currentPage);
  }, [isSearching, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const getRecipients = async (currentPage) => {
    try {
      setIsLoading(true);
      let recipientsData;

      if (isSearching) {
          const { data } = await getRecipientsDataBySearch(searchField.searchItem, searchField.search);
          recipientsData = data; 
      } else if (!isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getRecipientsData(currentPage || page);
        recipientsData = data;
      }

      recipientsData.rows.forEach(row => {
        if (row.paymentOriginId === 2) {
          row.paymentOriginId = 'Zoop';
        } else if (row.paymentOriginId === 3) {
          row.paymentOriginId = 'Iugu';
        }
      });

      setRecipients(recipientsData.rows);
      setTotalItems(recipientsData.count);
      setTotalPages(recipientsData.pages);
      setPage(recipientsData.page);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      dispatch(showAlert('error', 'Something went wrong'));
    }
  };

  const handleSubmitSearch = searchBox => {
    if (searchBox.search === 'zoop') {
      searchBox.search = 2;
    } else if (searchBox.search === 'iugu') {
      searchBox.search = 3;
    }

    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Recipients ({totalItems})</h1>

        <SearchBox
          selectItems={['paymentOriginId', 'channelId', 'status', 'enabled', 'paymentOriginToken']}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          onKeyDown={escape}
        />
      </div>

      <DataTable
        head={headers}
        body={recipients}
        action
        bodyColumn={headers}
        linkPath={'recipients'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default Recipients;
